'use strict';

$ = jQuery;

function filterVehicles() {
  var ranking = $('#ranking');
  var loader = $('#ranking_loader_container');

  ranking.empty();
  loader.addClass('d-flex');

  var filters = {
    action: 'jc_generate_ranking',
    price_min: $('#ranking-jc-min-price').val(),
    price_max: $('#ranking-jc-max-price').val()
  };

  // Faz requisição e altera resultados exibidos
  $.ajax({
    url: rankingAjaxHandler.url,
    type: 'GET',
    data: filters,
    beforeSend: function beforeSend() {
      loader.removeClass('d-none');
      loader.addClass('d-flex');
    },
    success: function success(response) {
      loader.removeClass('d-flex');
      loader.addClass('d-none');
      ranking.html(response.data);
    },
    error: function error(data) {}
  });
}

function setupRanking() {
  $('#ranking-jc-min-price, #ranking-jc-max-price').keyup(function () {
    if (window.ranking_jc) {
      clearTimeout(window.ranking_jc);
    }
    window.ranking_jc = setTimeout(filterVehicles, 1000);
  });

  $('#ranking-jc-min-price, #ranking-jc-max-price').change(filterVehicles);
  filterVehicles();
  $('#ranking-jc-min-price').mask('000.000.000.000.000', { reverse: true });;
  $('#ranking-jc-max-price').mask('000.000.000.000.000', { reverse: true });;
}